@if(!businessId){
<brt-business-list (selected)="router.navigate([basePath, 'transact', $event.Id])"></brt-business-list>
}
@else {
<div class="card">
  <h3>Unprocessed Transactions</h3>
  <brt-transact-details mode="simple"></brt-transact-details>
</div>

<div>
  <h3>Settlement / Transaction History</h3>
  <p-button label="Manual weekly settlement" [routerLink]="[basePath, 'transact', businessId, 'current']" />
  <p-table [value]="transacts" dataKey="Id" [loading]="loading" [rowHover]="true"
    styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm tw-max-w-[100vw]">
    <ng-template pTemplate="header">
      <tr>
        <th>Code</th>
        <th>Period</th>
        <th>Requested Time</th>
        <th>Status</th>
        <th>Quantity</th>
        <th>Payable</th>
        <th>Actual paid</th>
        <th>Remaining</th>
        <th>Paid Time</th>
        <th>Payment reference</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transact>
      <tr>
        <td class="tw-font-bold"><a [routerLink]="[basePath,'transact', businessId, transact.Id]">{{transact.Code||'[No
            Code]'}}</a></td>
        <td>{{transact.PeriodStart | date: 'mediumDate'}} � {{transact.PeriodEnd | date: 'mediumDate'}}<span *ngIf="transact.PeriodEnd"> (end exclusive)</span></td>
        <td>{{transact.RequestTime | date: 'short'}}</td>
        <td>{{transact.Status}}</td>
        <td>{{transact.Quantity}}</td>
        <td>{{transact.Payable | currency: '£'}}</td>
        <td>{{transact.RecordedPaidAmount | currency: 'GBP'}}</td>
        <td>{{transact.RemainingAmount | currency: 'GBP'}}</td>
        <td>{{transact.PaidDate | date: 'short'}}</td>
        <td>{{transact.PaymentReference}}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
}